import { atom } from "recoil";

export const isQiankun = atom({
  key: "isQiankun",
  default: false,
});
